import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledEngineProvider } from '@mui/material/styles';


import { Country } from '../../types/Country';
import { STATE_DEFAULT, siteLang } from '../../utils/variables';
import CustomExpandIcon from '../../utils/customAccordionIcon';
import { getTermsByLang, getColorForRiskClass, getTranslatedRiskClassValue, getTranslatedValueForPolicy } from '../../utils/utils';

type Props = {
  data: Array<Country>;
}

const List: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const data = props.data;

  const countriesToRender = data.filter(country => {
    return country.state === STATE_DEFAULT;
  });

  const sortCountries = () => {
  if (siteLang == "en")
      return countriesToRender.sort((a,b) => a.nameEng.localeCompare(b.nameEng))
    else
      return countriesToRender.sort((a,b) => a.nameFin.localeCompare(b.nameFin))   
  }

  const sortedData = sortCountries();

  const renderRiskClassExplanation = (riskClass: string) => {
    const value = getTranslatedRiskClassValue(riskClass);
    if (value) {
      return t(value);
    }
  }

  const renderPolicyExplanation = (policy: string) => {
    const value = getTranslatedValueForPolicy(policy);
    if (value) {
      return t(value);
    }
  }

  return (
    <div className="list-container">
      {/* Removing the need for !important, by changin the CSS injection order. */}
      <StyledEngineProvider injectFirst>
        {/* creates a new array from calling a function for every array element, country = currentValue */}
        {sortedData.map((country, index) => (
          <Accordion key={country.geoJson.id} data-index={index}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                {siteLang === 'en' && country.nameEng}
                {siteLang === 'fi' && country.nameFin}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography component={'span'}>
                <div className="country-data-info-container">
                  <div className="country-data-info-row">
                    <div className="country-data-info-box">
                      <label style={{fontWeight:"bold"}}>{t('countryData:info.contact')}</label>
                      <div className="country-data-info-contact">
                        <p>{country.countrySpecialist}</p>
                        <p>{country.countrySpecialistPhone}</p>
                        <p>{t('countryData:info.email')}</p>
                      </div>
                    </div>
                    <div className="country-data-info-box">
                      <label style={{fontWeight:"bold"}}>{t('countryData:info.geopolitics')}</label>
                      <div className="country-data-info-risk-class">
                        <span className="country-data-info-risk-class-value" style={{ backgroundColor: getColorForRiskClass(country.riskClass) }}>
                          {country.riskClass}
                        </span>
                        <label>{renderRiskClassExplanation(country.riskClass)}</label>
                      </div>
                      <label style={{fontWeight:"bold"}}>{t('countryData:info.landClass')}</label>
                      <div className="country-data-info-policy">
                        <span className="country-data-info-policy-value" style={{ backgroundColor: "#383838" }}>
                          {country.classFin}
                        </span>
                        <label>{renderPolicyExplanation(country.classFin)}</label>
                      </div>
                    </div>
                  </div>
                  <div className="country-data-info-row">
                    <div className="country-data-info-box">
                      <label style={{ fontWeight: "bold" }}> {t('countryData:info.condition')} </label>
                      <div className="country-data-info-terms">
                        <p>{getTermsByLang(country)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </StyledEngineProvider>
    </div>
  )
}

export default List;